import augustusClient from '@/services/axios/augustus'

function getOrgId() {
  return localStorage.getItem('organizationId') || undefined
}

export function getSafetySummary({ from, to }) {
  return augustusClient.get('/api/safety/summary', { params: { from, to, organizationId: getOrgId() } })
}

export function getSafetyReport({ from, to }) {
  return augustusClient.get('/api/safety/report', { params: { from, to, organizationId: getOrgId() } })
}

export function getSafetyVehicles({ from, to }) {
  return augustusClient.get('/api/safety/vehicles', { params: { from, to, organizationId: getOrgId() } })
}

export function getSafetyEvents({ from, to, device_id, event_type, limit, offset }) {
  return augustusClient.get('/api/safety/events', {
    params: { from, to, device_id, event_type, limit: limit || 50, offset: offset || 0, organizationId: getOrgId() },
  })
}

export function getSafetyScoreDistribution({ from, to }) {
  return augustusClient.get('/api/safety/score-distribution', { params: { from, to, organizationId: getOrgId() } })
}
